import { LoadState } from "../../../constants/enums";

export interface IOperatingStatementsState {
  list: IOperatingStatement[];
  loading: LoadState;
  totalRecords: number;
}

export interface IOperatingStatement {
  gl_account_code: string | null;
  gl_account_name: string | null;
  amount: string | null;
  account_type: string | null;
  yte: string | null;
  pct: string | null;
  yct: string | null;
}


export const initialOperatingStatementsState: IOperatingStatementsState = {
    list: [],
    loading: LoadState.NotLoaded,
    totalRecords: 0,
}